import React from "react";
import styles from "./Modal.module.scss";
import { Dialog, DialogContent, DialogTitle, useMediaQuery } from "@mui/material";
import { combineClasses } from "@/lib/utils";
import type { ModalProps } from "@/services/api/modal";

const MOBILE_BREAKPOINT = "(max-width: 640px)";

const Modal = ({
  modalOpen,
  closeModal,
  heading,
  children,
  doNotClose = false,
  className = "",
  bodyClassName = "",
  fullScreenOnMobile = false,
  bottomSheetOnMobile = false,
}: ModalProps) => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const isFullScreen = fullScreenOnMobile && isMobile;
  const isBottomSheet = bottomSheetOnMobile && isMobile && !isFullScreen;

  const handleClose = (
    _event: object,
    reason?: "backdropClick" | "escapeKeyDown",
  ) => {
    if (doNotClose && (reason === "backdropClick" || reason === "escapeKeyDown")) {
      return;
    }
    closeModal(false);
  };

  return (
    <Dialog
      className={combineClasses(isBottomSheet && styles.modalBottomSheet)}
      open={modalOpen}
      onClose={handleClose}
      fullWidth
      fullScreen={isFullScreen}
      maxWidth={isFullScreen ? false : "sm"}
      slotProps={{
        paper: {
          className: combineClasses(
            styles.modalDiv,
            isFullScreen && styles.modalDivFullScreen,
            isBottomSheet && styles.modalDivBottomSheet,
            className,
          ),
        },
      }}
    >
      <DialogTitle
        className={combineClasses(
          styles.modalHeader,
          isFullScreen && styles.modalHeaderFullScreen,
        )}
      >
        {heading}
      </DialogTitle>
      <DialogContent
        className={combineClasses(
          styles.modalBody,
          isFullScreen && styles.modalBodyFullScreen,
          bodyClassName,
        )}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
